var _defs, _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcceptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13.5px",
    height: "13.5px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-17.749133,-40.642699)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35639831,0,0,0.35639831,9.2885611,32.362697)",
    id: "_x30_02-success"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 76.21545,32.65862 46.266205,66.41249 28.12106,51.876865 c -0.87799,-0.68288 -2.048645,-0.48777 -2.731525,0.292665 -0.68288,0.87799 -0.487775,2.048645 0.292665,2.731525 L 45.193105,70.50978 C 45.583325,70.802445 45.97354,70.9 46.36376,70.9 c 0.585325,0 1.0731,-0.19511 1.46332,-0.68288 L 79.04453,35.097485 c 0.68288,-0.780435 0.68288,-2.048645 -0.19511,-2.731525 -0.68288,-0.58533 -1.95109,-0.58533 -2.63397,0.29266 z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptIcon);
export default __webpack_public_path__ + "static/media/AcceptIcon.a3c94b783c4c5552ff08c6321d1e5420.svg";
export { ForwardRef as ReactComponent };